/// <reference path='../_all.ts' />

module navigation {
  'use strict';

  export class ItemNavItem {
    constructor(
      public Name: string,
      public $anchorNav: navigation.AnchorNavItem
      ) { }
  }
}